import { ResourceType } from "@common/types/auditLog";
import { HistoryField } from "./history-fields";
import type { ResourceTypeConfig } from "./history-source-config";

export const TASK_FIELDS = [
    HistoryField.TITLE,
    HistoryField.STATUS,
    HistoryField.ASSIGNEE_ID,
    HistoryField.DUE_DATE,
    HistoryField.PRIORITY,
    HistoryField.ESTIMATED_TIME,
    HistoryField.ENTITIES,
    HistoryField.FINANCIAL_DOCUMENTS,
    HistoryField.BLOCKED_BY_TASKS,
    HistoryField.BLOCKING_TASKS,
    HistoryField.RELATED_TASKS,
    HistoryField.CLOSE_STAGE_ID,
    HistoryField.CLOSE_ID,
];

/** Fields only work item rows carry; those rows show only in one work item's history. */
export const WORK_ITEM_HISTORY_FIELDS: readonly HistoryField[] = [
    HistoryField.WORK_START_DATE,
    HistoryField.WORK_DELIVERY_DATE,
    HistoryField.PREPARER_ID,
    HistoryField.REVIEWER_ID,
    HistoryField.MANAGER_ID,
];

export const FINANCIAL_ACCOUNT_FIELDS = [
    HistoryField.ENTITY_ID,
    HistoryField.STATUS,
    HistoryField.DESCRIPTION,
];

export const CLASS_FIELDS = [
    HistoryField.LABEL,
    HistoryField.ORDER,
    HistoryField.PARENT_CLASS_ID,
    HistoryField.ROOT_CLASS_ID,
];

export const ACCOUNT_FIELDS = [
    HistoryField.NAME,
    HistoryField.CODE,
    HistoryField.TYPE,
    HistoryField.PARENT_GROUP_ID,
    HistoryField.ARCHIVED,
    HistoryField.ROLE,
    HistoryField.RELATED_ENTITY_ID,
    HistoryField.FORM_1099_BOX,
    HistoryField.OPENING_BALANCE,
];

export const ACCOUNT_GROUP_FIELDS = [
    HistoryField.NAME,
    HistoryField.TYPE,
    HistoryField.PARENT_GROUP_ID,
];

// `parentGroup` is the snapshot's path label beside `parentGroupId`; it
// reaches CREATE and DELETE diffs only and is never a drawer line.
export const COA_HIDDEN_FIELDS: readonly string[] = [
    HistoryField.ORDER,
    HistoryField.PARENT_GROUP,
];

export const DOCUMENT_DISPLAY_FIELDS = [
    HistoryField.FILE_NAME,
    HistoryField.DOCUMENT_CATEGORY_ID,
    HistoryField.LOAN_ID,
    HistoryField.ENTITY_ID,
    HistoryField.FINANCIAL_ACCOUNT_ID,
];

export const DOCUMENT_RESOURCE_TYPE_CONFIGS: ResourceTypeConfig[] = [
    {
        resourceType: ResourceType.FINANCIAL_DOCUMENT,
        fields: DOCUMENT_DISPLAY_FIELDS,
        resolveEntity: true,
    },
];

export const JOURNAL_ENTRY_FIELDS = [
    HistoryField.DATE,
    HistoryField.NOTE,
    HistoryField.LINES,
    HistoryField.CREATOR_ID,
    HistoryField.ACCOUNTING_LEDGER_ID,
    HistoryField.REVERSED_AT,
    HistoryField.RECURRING_RULE_ID,
    HistoryField.FINANCIAL_DOCUMENT,
];
